import styled from "styled-components";
import Styleguide, { Colors, theme } from "../../theme";
import IconButton from "../../assets/Icon/IconButton/IconButton";

export const FooterTag = styled.footer`
  padding: 24px;
  margin-top: 64px;
  background-color: ${theme(Colors.gray[100], Colors.gray[400])};
`;

export const FooterContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  font-size: 14px;

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    width: 626px;
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  font-family: ${Styleguide.fonts.body.name};
  > input {
    height: 40px;
    font-size: 16px;
  }

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    width: 312px;
  }
`;

export const TextGray = styled.div`
  color: ${theme(Colors.gray[300], Colors.gray[200])};
  font-family: ${Styleguide.fonts.body.name};

  > p {
    font-size: 14px;
  }

  > a {
    cursor: pointer;
    text-decoration: none;
  }
`;

export const FooterLink = styled.a`
  display: flex;
  cursor: pointer;
  font-family: ${Styleguide.fonts.body.name};
  font-weight: ${Styleguide.fontWeights.bold};
  color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
  text-decoration: none;
  text-size: 14px;

  > div {
    > p {
      margin: 0;
    }
  }

  :focus {
    outline-width: 3px;
    outline-style: solid;
    border-radius: 8px;
    outline-offset: 2px;
    outline-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
  }
`;

export const HelpContainer = styled(FooterLink)`
  flex-direction: row;
  margin-top: 25px;
  justify-content: space-between;

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    margin-top: auto;
    gap: 10px;
  }
`;

export const SearchTag = styled(IconButton)`
  color: ${theme(Colors.gray[300], Colors.gray[200])};
`;

export const FooterTitle = styled.h3`
  font-family: ${Styleguide.fonts.heading.name};
  color: ${theme(Colors.black, Colors.white)};
  font-size: ${Styleguide.fontSizes[20]};
  font-weight: ${Styleguide.fontWeights.bold};
  line-height: 24px;
  margin-bottom: 10px;

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    margin-bottom: 8px;
  }
`;

export const Line = styled.hr`
  width: 100%;
  margin-top: 21px;
  margin-bottom: 24px;
`;
